export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'common.refresh': 'Refresh',
  'common.action': 'Action',
  'common.settings': 'Settings',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.recommended': 'Recommended',
  'common.create': 'Create',
  'common.update': 'Update',
  'common.operationFailed': 'Operation failed',
  'common.reset': 'Reset',
};
